<script>
    import {scaleLinear, scaleTime} from 'd3-scale';
    import { min, max, sub } from 'date-fns';

    export let points;

    // Take the .x attribute with map and then find the lowest/highest
    const xStart = min(points.map((point) => point.x));
    const xEnd = max(points.map((point) => point.x));

    const yStart = points.map((point) => point.y).reduce((previous, current) => previous < current ? previous : current);
    const yEnd = points.map((point) => point.y).reduce((previous, current) => previous > current ? previous : current);

    const yTicks = [];
    const yStepSize = (yEnd - yStart) / 10;
    let yStep = yStart;
    while(yStep <= yEnd) {
      yTicks.push(Math.round(yStep));
      yStep+=yStepSize;
    }

    const xTicks = [];
    const xStepDays = 5;
    let xStep = sub(xStart, { days: 2 });

    while(xStep <= xEnd) {
        xTicks.push(xStep);
        const nextStep = new Date(xStep);
        nextStep.setDate(xStep.getDate() + xStepDays);
        xStep = nextStep;
    }

    const padding = {top: 20, right: 15, bottom: 20, left: 25};

    let width = 500;
    let height = 200;

    $: xScale = scaleTime()
            .domain([new Date(2020, 2, 1), new Date(2020, 2, 31)])
            .range([0, 200]);

    $: yScale = scaleLinear()
            .domain([Math.min(...yTicks), Math.max(...yTicks)])
            .range([height - padding.bottom, padding.top]);

    $: minX = points[0].x;
    $: maxX = points[points.length - 1].x;
    $: path = `M${points.map(p => `${xScale(p.x)},${yScale(p.y)}`).join('L')}`;
    $: area = `${path}L${xScale(maxX)},${yScale(0)}L${xScale(minX)},${yScale(0)}Z`;

    function formatMobile(tick) {
        return "'" + tick % 100;
    }

    function formatXtick(tick) {
        return tick.getDate() + '/' + (tick.getMonth() + 1);
    }
</script>

<h2>Ticket validations per day</h2>

<div class="chart" bind:clientWidth={width} bind:clientHeight={height}>
    <svg>
        <!-- y axis -->
        <g class="axis y-axis" transform="translate(0, {padding.top})">
            {#each yTicks as tick}
                <g class="tick tick-{tick}" transform="translate(0, {yScale(tick) - padding.bottom})">
                    <line x2="100%"></line>
                    <text y="-4">{tick} {tick === Math.max(...yTicks) ? ' ticket validations' : ''}</text>
                </g>
            {/each}
        </g>

        <!-- x axis -->
        <g class="axis x-axis">
            {#each xTicks as tick}
                <g class="tick tick-{ tick }" transform="translate({xScale(tick)},{height})">
                    <line y1="-{height}" y2="-{padding.bottom}" x1="0" x2="0"></line>
                    <text y="-2">{formatXtick(tick)}</text>
                </g>
            {/each}
        </g>

        <!-- data -->
        <path class="path-area" d={area}></path>
        <path class="path-line" d={path}></path>
    </svg>
</div>

<style>
    .chart, h2, p {
        width: 100%;
        max-width: 500px;
        margin-left: auto;
        margin-right: auto;
    }

    svg {
        position: relative;
        width: 100%;
        height: 200px;
        overflow: visible;
    }

    .tick {
        font-size: .725em;
        font-weight: 200;
    }

    .tick line {
        stroke: #aaa;
        stroke-dasharray: 2;
    }

    .tick text {
        fill: #666;
        text-anchor: start;
    }

    .tick.tick-0 line {
        stroke-dasharray: 0;
    }

    .x-axis .tick text {
        text-anchor: middle;
    }

    .path-line {
        fill: none;
        stroke: rgb(0, 100, 100);
        stroke-linejoin: round;
        stroke-linecap: round;
        stroke-width: 2;
    }

    .path-area {
        fill: rgba(0, 100, 100, 0.2);
    }
</style>

